<template>
  <t-filter-wrapper :label="label">
    <t-select
      :placeholder="placeholder"
      :value="value"
      :options="options"
      :get-option-key="(option) => option.key"
      :reduce="(option) => option.key"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
    />
  </t-filter-wrapper>
</template>

<script>
import TFilterWrapper from './TFilterWrapper.vue';
import TSelect from '../TSelect/TSelect.vue';

export default {
  name: 't-filter-boolean',

  components: {
    TFilterWrapper,
    TSelect,
  },

  props: {
    value: {
      type: [Boolean, Array],
      required: false,
      default: () => [],
    },

    label: {
      type: String,
      required: false,
      default: null,
    },

    trueLabel: {
      type: String,
      required: false,
      default: 'Yes',
    },

    falseLabel: {
      type: String,
      required: false,
      default: 'No',
    },

    placeholder: {
      type: String,
      required: false,
      default: null,
    },
  },

  computed: {
    options() {
      return [
        { key: true, label: this.trueLabel },
        { key: false, label: this.falseLabel },
      ];
    },
  },
};
</script>
